import React, { useEffect, useState, useRef} from 'react'
import PropTypes from "prop-types";
import Select from 'react-select'
import Flatpickr from "react-flatpickr";
import PostUploadsBlock from '../Posts/PostUploadsBlock/PostUploadsBlock';
import { HTTP } from '../../api/resources';
import TemplateDropdown from '../Templates/TemplateDropdown';
import TemplateVariableCard from '../Templates/TemplateVariableCard';
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import {
  useTitleVariable,
  getOwnerType,
  getBeneficiaryFields,
  getDonorFields,
  detectTemplateVariables,
  detectTitleVariables,
  useVariable
} from "../Helpers/Functions/Templates";
import GroupPostInfoModal from '../Helpers/Modal/InfoModals/GroupPostInfoModal';
import IncreaseLimit from './Modals/IncreaseLimit';
import SummaryModal from '../Helpers/Modal/Posts/SummaryModal';
import InfoModal from './Modals/InfoModal';

function Form(props) {
  const [saving, setSaving] = useState(false)
  const [isDirty, setDirty] = useState(false)
  const [ownerOptions, setOwnerOptions] = useState(null)
  const allowManagerPosts = true

  // props
  const [team, setTeam] = useState(props.team)
  const [user, setUser] = useState(props.user)
  const [users, setUsers] = useState(props.users)
  const [groupPost, setGroupPost] = useState(props.group_post)
  const [param, setParams] = useState(props.params)
  const [post, setPost] = useState(props.post)
  const [file, setFile] = useState(null)
  const [newPost, setNewPost] = useState(props.new_post)
  const [templates, setTemplates] = useState(props.templates)
  const [openLimit, setOpenLimit] = useState(false)
  const [postSummary, setPostSummary] = useState({sender: '', receiver: '', action: ''})
  const [showPostSummary, setShowPostSummary] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)


  // Audience from posts
  const [audienceOptions, setAudienceOptions ] = useState(props.availableAudiences)
  const _usingAudience = post.audience_members && post.audience_members.length > 0;
  const [usingAudience, setUsingAudience] = useState(_usingAudience);
  const [postTemplate, setPostTemplate] = useState(groupPost.template ? groupPost.template : null)

  // post states
  const [data, setData] = useState(groupPost.posts ? groupPost.posts : [])
  const [count, setCount] = useState(1)
  const [index, setIndex] = useState(1)
  const [postCleaner, setPostCleaner] = useState({
    id: data.length + 1,
    title: postTemplate && groupPost.use_template ? postTemplate.title : '',
    content: postTemplate && groupPost.use_template ? postTemplate.content : '',
    date: post.published_at,
    files: [],
    owner: null,
    audience: null,
    post_type: 'user',
    public_project_audience: false
  }) //will be used to clean the holder state up

  const [postData, setPostData] = useState(postCleaner) 
  const hasPotentialAudience = postData.post_type && postData.post_type == 'project' ? 
  audienceOptions.filter(o => o.type == 'project') && audienceOptions.filter(o => o.type == 'project').length > 0 :
  audienceOptions.filter(o => o.type == 'user') && audienceOptions.filter(o => !o.type || o.type == 'user').length > 1

  // TEMPLATE FEATURE
  const [template, setTemplate] = useState(props.template);
  const [templateVariable, setTemplateVariable] = useState(false)
  const [showTemplateTitle, setShowTemplateTitle] = useState(false)
  const [showTemplateContent, setShowTemplateContent] = useState(false)
  const [senderVariable, setSenderVariable] = useState([])
  const [titleVariable, setTitleVariable] = useState(false)
  const [receiverVariable, setReceiverVariable] = useState([])
  const [donorFields, setDonorFields] = useState(props.customFields.donor_fields.map(f => f.replace(' ', '_').toLowerCase()))
  const [beneficiaryFields, setBeneficiaryFields] = useState(props.customFields.beneficiary_fields.map(f => f.replace(' ', '_').toLowerCase()))
  const [organizationVariable, setOrganizationVariable] = useState(['name'])
  const [totalVariables, setTotalVariables] = useState([])
  const [templateOwnerType, setTemplateOwnerType] = useState('')

  // filters
  const [filterMedia, setFilterMedia] = useState(false)
  const [renderedAssets, setRenderedAssets] = useState([])
  const [extractedMedia, setExtractedMedia] = useState([])
  const [fileHolder, setFileHolder] = useState([])
  const [mediaHolder, setMediaHolder] = useState([])
  const [filterInput, setFilterInput] = useState('')
  const filterOptions = [
    {id: 0, name: 'All media files'},
    {id: 1, name: 'Images only'},
    {id: 2, name: 'Videos only'},
    {id: 3, name: 'Documents only'}
  ]
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0])
  const [openMediaGuide, setOpenMediaGuide] = useState(false)
  const allowedVariables = user.user_type == "manager" || user.user_type == 'assistant_manager' || user.user_type == 'sponsorship_manager'

  // re-render
  useEffect(() => {
    detectTitleVariables(postData, setTitleVariable)
    detectTemplateVariables(postData, setTemplateVariable)
    clearVariables()
    arrangeVariables()
  }, [postData.title, postData.content, postData.owner])

  useEffect(() => {
    if (postData.audience && postData.post_type == 'project' && postData.audience.length > 0) {
      if (postData.audience[0].public_disabled) setPostData({...postData, public_project_audience: false})
    }
  }, [])

   // setting variables
   const arrangeVariables = () => {
    // if postOwner is available, then evaluate
    if (postData.owner) {
      if (postData.owner.user_type == "donor") {
        setSenderVariable(donorFields)
        setReceiverVariable(beneficiaryFields)
      } else if (postData.owner.user_type == "beneficiary") {
        setSenderVariable(beneficiaryFields)
        setReceiverVariable(donorFields)
      } else if (
        postData.owner.user_type == "manager" || postData.owner.user_type == "assistant_manager" ||
        postData.owner.user_type == "sponsorship_manager") {
        setTotalVariables([...donorFields, ...beneficiaryFields])
        setReceiverVariable([...new Set(totalVariables)])
        setSenderVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
      }
    }
  }

  // clear variables
  const clearVariables = () => {
    setReceiverVariable([])
    setSenderVariable([])
    setTotalVariables([])
  }

  // fill in variables on click
  const useVariable = (placeholder) => {
    let pattern = /(?:^|\s)\{\{(?!\S)/
    setPostData({...postData, content: template.content.replace(pattern, ` ${placeholder}`)})
    setTemplateVariable(false)
  }

  // Fill post data with selected temmplate
  const fillTemplate = (data) => {
    setPostData({...postData, title: data.title, content: data.content})
  }

  // donors and beneficiaries for user selection
  const donors = users.filter(user => {
    if (user.user_type == 'donor') {
      return user
    }
  })

  const beneficiaries = users.filter(user => {
    if (user.user_type == 'beneficiary') {
      return user
    }
  })

  useEffect(() => {
    if (allowManagerPosts && user.user_type !== 'sponsorship_manager') initializePostAsOptions()
    if (allowManagerPosts && user.user_type == 'sponsorship_manager') initializeBeneficiaryOptions()
    if (!groupPost.posts || groupPost.posts.length == 0) {
      setData([])
      setCount(1)
      setPostData(postCleaner)
    } else if (groupPost.posts) {
      setCount(data.length + 1)
    }
  }, [])

  useEffect(() => {
    if(postData.owner && !post.id) {
      const fetchData = async () => {
        const data = await initializeAudienceOptions(postData.owner);
        setAudienceOptions(data.data.users)
        setUsingAudience(false)
      }

      fetchData().catch(console.error);
    }
  }, [postData.owner])

  const initializeAudienceOptions = async (user) => {
    let userId = user && user.id ? user.id : post.user_id
    return HTTP.get(`/users/${userId}/get_audience.json`)
  }

  const initializeBeneficiaryOptions = () => {
    let updatedOptions = null
    if (props.beneficiaries) {
      updatedOptions = _.concat(props.beneficiaries)
    }
    updatedOptions = _.orderBy(updatedOptions, ['first_name', 'asc'], ['last_name'], ['asc'])
    updatedOptions = _.concat(user, updatedOptions)
    setOwnerOptions(updatedOptions)
    setPostData({...postData, owner: user})
  }

  const initializePostAsOptions = () => {
    let updatedOptions = null
    if (groupPost.add_donor && !groupPost.add_beneficiary) {
      updatedOptions =  _.concat(donors)
    } else if (groupPost.add_beneficiary && !groupPost.add_donor) {
      updatedOptions =  _.concat(beneficiaries)
    } else if (groupPost.add_beneficiary && groupPost.add_donor) {
      updatedOptions = _.concat(donors, beneficiaries)
    }
    updatedOptions = _.orderBy(updatedOptions, ['first_name', 'asc'], ['last_name'], ['asc'])
    updatedOptions = _.concat(user, updatedOptions)
    setOwnerOptions(updatedOptions)
    setPostData({...postData, owner: user})
  }

  // to select a file
  const selectFile = (data) => {
    setPostData({...postData, files: [...postData.files, data]})
  }

  // to remove a file from selection
  const unselectFile = (data) => {
    setPostData({...postData, files: postData.files.filter(file => {
      if (file.id !== data.id) {
        return file
      }
    })})
  }

  // warning if post is not saved
  window.onbeforeunload = (event) => {
    if (isDirty) {
      return ''
    }
  }

  // post next, previous, re-render and save for later
  useEffect(() => {
    // If it is a new post
  if (newPost) {
    if (data) {
      setPostData({...postData, owner: user})
    } else {
      setPostData({...postData, id: 1, owner: user})
    }
  } else {
    let filteredArray = groupPost.posts.filter(current => current.id == parseInt(param))
    setPostData(filteredArray[0])
    setData(data.filter(current => current.id !== parseInt(param)))
  }
  }, [count])

  // Use effect for media files auto assignment 
  useEffect(() => {
    let validSettings = groupPost.use_media && groupPost.auto_select_media
    let rightOwnerType = postData.owner && (postData.owner.user_type == 'donor' || postData.owner.user_type == 'beneficiary')

    if (groupPost.images && validSettings && rightOwnerType) {
      let temp = groupPost.images 
      temp = temp.filter(file => {
        let match = file.filename.match(/\{\{(\d+)\}\}/);
        let importId = match ? match[1] : null;
        if (importId && parseInt(importId) == postData.owner.import_id) {
          return file
        }
      })
      setPostData((current) => ({...current, files: temp}))
    }

    if (validSettings && !rightOwnerType) setPostData((current) => ({...current, files: []}))
  }, [postData.owner, count])

  const proceed = () => {
    // validations
    if (!postData.title.length || !postData.content.length) {
      Alert.show('notice', 'Title and content are required fields')
      return ''
    }

    if (postData.post_type == 'project' && (!postData.audience || postData.audience.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
      return
    }

    setCount(count + 1)

    // if new post
    if (count >= data.length) {
      setPostData({...postData})
      setData([...data, {...postData, id: data.length + 1}])
      setPostData(postCleaner)
      return ''
    }
  }

  // continue later
  const continueLater = async () => {
    setSaving(true)

    if (postData.post_type == 'project' && (!postData.audience || postData.audience.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
      return
    }

    if (postData.title.length > 0 && postData.content.length > 0) {
      setPostData({...postData})
      data.push({...postData, id: data.length + 1})
    }

    if (!data || data.length == 0) {
      window.location = '/group/post'
      return
    }

    const posts = {
      posts: data
    }

    try {
      await updatePost(posts)
    } catch {
      Alert.show('error', 'Error saving posts, try again')
      setSaving(false)
      return ''
    }

    setSaving(false)
    setDirty(false)
    Alert.show('notice', 'Posts saved successfully')
    setTimeout(() => {
      window.location = '/group/post'
    }, 1500)
  }

  // save data in model
  const savePost = async () => {
    setSaving(true)

    // validations
    if (postData.post_type == 'project' && (!postData.audience || postData.audience.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
      return
    }

    if (!postData.title.length || !postData.content.length) {
      Alert.show('notice', 'You have to fill the post before save')
      setSaving(false)
      return ''
    }

    setPostData({...postData})


    const posts = {
      posts: data.push({...postData, id: data.length + 1})
    }

    try {
      await updatePost(posts)
    } catch {
      Alert.show('error', 'Error saving posts, try again')
      setSaving(false)
      return ''
    }

    setSaving(false)
    setDirty(false)
    Alert.show('notice', 'Posts saved successfully')
    setTimeout(() => {
      window.location = '/group/post'
    }, 1500)
  }

  const updatePost = (posts) => {
    return HTTP.patch('/group/post/form', data)
  }

  const editImages = () => {
    window.location = '/group/post/media'
  }

  const increaseLimit = () => {
    setOpenLimit(true)
  }

  // save exisiting post
  const editPost = async () => {
    // validations
    if (postData.post_type == 'project' && (!postData.audience || postData.audience.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
      return
    }

    if (!postData.title.length || !postData.content.length) {
      Alert.show('notice', 'Title and content are required fields')
      return ''
    }

    const posts = {
      posts: data.push(postData)
    }

    try {
      await updatePost(posts)
    } catch {
      Alert.show('error', 'Error saving posts, try again')
      setSaving(false)
      return ''
    }

    setSaving(false)
    setDirty(false)
    Alert.show('notice', 'Posts saved successfully')
    setTimeout(() => {
      window.location = '/group/post'
    }, 1500)
  }

  // Logic for filters

  // extract media from previous posts
  const extractMedia = () => {
    setExtractedMedia([])
    data.map(post => {
      post.files.map(file => {
        extractedMedia.push(file)
      })
    })
  }

  // remove extracted media files from main file
  const removeExtractedFiles = () =>  {
    let mediaHolder = groupPost.images
    extractedMedia.map(media => {
      mediaHolder = mediaHolder.filter(file => file.key !== media.key)
    })
    setFileHolder(mediaHolder)
    setRenderedAssets(mediaHolder)
    setMediaHolder(mediaHolder)
  }

  // filter media based on selections
  const filterWithSelection = (selection) => {
    if (selection.id == 0) {
      setRenderedAssets(fileHolder)
      setMediaHolder(fileHolder)
    } else if (selection.id == 1) {
      let images = fileHolder
      images = images.filter(image => image.file_type == 'image')
      setRenderedAssets(images)
      setMediaHolder(images)
    } else if (selection.id == 2) {
      let videos = fileHolder
      videos = videos.filter(video => video.file_type == 'video')
      setRenderedAssets(videos)
      setMediaHolder(videos)
    } else if (selection.id == 3) {
      let docs = fileHolder
      docs = docs.filter(doc => doc.file_type == 'pdf' || doc.file_type == 'doc')
      setRenderedAssets(docs)
      setMediaHolder(docs)
    }
  }

  useEffect(() => {
    if (!data || data.length < 1) {
      if (filterMedia) {
        setFilterMedia(false)
      }
    }
    if (data) {
      extractMedia()
    if (filterMedia) {
      removeExtractedFiles()
      setSelectedFilter(filterOptions[0])
    } else {
      setRenderedAssets(groupPost.images)
      setFileHolder(groupPost.images)
      setSelectedFilter(filterOptions[0])
    }} else {
      setFileHolder(groupPost.images)
      setRenderedAssets(groupPost.images)
    }
  }, [filterMedia, count])

  const addAllImages = () => {
    let images = fileHolder
    images = images.filter(image => image.file_type == 'image')
    setPostData({...postData, files: images})
  }

  const updateSkipPostSummary = async () => {
    setSaving(true)

    try {
        let response = await skipPostRequest()
        setSaving(false)
        Alert.show('notice', response.data ? 'Post summary will now be skipped' : 'Post summary will now appear')
        setGroupPost({...groupPost, skip_post_summary: response.data})
        return
    } catch {
        Alert.show('error', 'Failed to update, try again')
        setSaving(false)
    }
  }

  const skipPostRequest = () => {
    return HTTP.patch(`/group/post/update_post_summary`)
  }

  const prepareDataForSummary = (actionType) => {
    let presentAudience = postData.audience && postData.audience.length > 0 
    let sender = postData.owner.last_name ? `${postData.owner.first_name} ${postData.owner.last_name}` : postData.owner.first_name
    let receiver = presentAudience ? postData.audience.map(audience => audience.name).join(', ') : 'All your connections'
    if ((postData.owner.user_type == 'manager' || postData.owner.user_type == 'assistant_manager') && !presentAudience) {
      receiver = `All of your ${(team.donor_title + ', ' + team.beneficiary_title).toLowerCase()} and users`
    }
    setPostSummary({sender: sender, receiver: receiver, action: actionType})

    if (!groupPost.skip_post_summary) {
      setShowPostSummary(true)
      return
    }

    if (groupPost.skip_post_summary && (postData.owner.user_type == 'manager' || postData.owner.user_type == 'assistant_manager')) {
      setShowPostSummary(true)
      return
    }

    runRelevantAction(actionType)
  }

  const runRelevantAction = (actionType) => {
    if (actionType == 'continue-later') continueLater()
    if (actionType == 'proceed') proceed()
    if (actionType == 'save-post') savePost()
    if (actionType == 'edit-post') editPost()

    setShowPostSummary(false)
    setPostSummary({sender: '', receiver: '', action: ''})
  }

  // end post at the current number
  const endPost = async () => {
    // determine the new limit and update data state if the current post is filled
    let actualCount = 0 
    if (postData.title.length > 0 && postData.content.length > 0) {
      if (postData.post_type == 'project' && (!postData.audience || postData.audience.length !== 1)) {
        Alert.show('notice', `You must select one audience for a ${team.project_title.toLowerCase()} post`)
        return
      }
      
      setPostData({...postData})
      data.push({...postData, id: data.length + 1})
      actualCount = count 
    } else {
      actualCount = count - 1
    }

    // edge case in the case there are 0 posts created, post limit cannot be 0
    if (!data || data.length < 1) {
      Alert.show('error', 'You have to create at least one post to end the multi-post here')
      return false 
    }

      // start saving
      setSaving(true)

    // update the post limit
    try {
        await patchRequest(actualCount)
    } catch {
        Alert.show('error', 'Failed to end post, try again')
        setSaving(false)
        return 
    }

    // prepare props
    const posts = {
      posts: data
    }

    // update posts 
    try {
      await updatePost(posts)
    } catch {
      Alert.show('error', 'Error saving posts, try again')
      setSaving(false)
      return ''
    }

    // alert success and redirect 
    setDirty(false)
    Alert.show('notice', 'Post ended successfully')
    setTimeout(() => window.location = '/group/post', 1500)
  }

  const patchRequest = (number) => {
      return HTTP.patch(`/group/post/limit/${number}`)
  }

  const updateUseTemplate = async () => {
    setSaving(true)
    let action = groupPost.use_template ? 'deactivate' : 'activate'

    try {
      let response = await templateRequest(action)
      setGroupPost({...groupPost, use_template: response.data})
      Alert.show('notice', 'Success! It will take effect in the next post.')
      setPostCleaner({
        ...postCleaner,
        title: postTemplate && response.data ? postTemplate.title : '',
        content: postTemplate && response.data ? postTemplate.content : '',
      })
      setSaving(false)
    } catch {
      Alert.show('error', 'Unable to update, please try again')
      setSaving(false)
    }
  }

  const templateRequest = (action) => {
    return HTTP.post(`/group/post/settings/use_template?type=${action}`)
  }

  const updateAutoSelectMedia = async () => {
    if (!groupPost.auto_select_media) {
      setOpenMediaGuide(true)
    }

    setSaving(true)
    let action = groupPost.auto_select_media ? 'deactivate' : 'activate'

    try {
      let response = await AutoSelectRequest(action)
      setGroupPost({...groupPost, auto_select_media: response.data})
      Alert.show('notice', 'Success! It will take effect in the next post.')
      setSaving(false)
    } catch {
      Alert.show('error', 'Unable to update, please try again')
      setSaving(false)
    }
  }

  const AutoSelectRequest = (action) => {
    return HTTP.post(`/group/post/settings/auto_select_media?type=${action}`)
  }

  // delete single post
  const handleDelete = async () => {
    try {
        await updateList(postData)
    } catch {
        Alert.show('error', 'Error delete post, try again')
        return ''
    }

    Alert.show('success', 'Post deleted successfully')
    setTimeout(() => {
        window.location = '/group/post'
    }, 1500)
  }

  // update post list
  const updateList = (data) => {
    return HTTP.delete(`/group/post/${data.id}`)
  }

  return (
    <div>
      <div class={templateVariable && !groupPost.use_media ? "override-container-style" : ""}>
        {newPost &&
          <div className="page-header header-flex">
          <h4 className="page-title">
            Post {count} of {groupPost.limit}
          </h4>

          {count >= groupPost.limit &&
            <div className="page-actions show-mobile">
                <div className="btn-group align-center">
                  <button
                    onClick={increaseLimit}
                    name="button"
                    className={`btn btn-primary`}
                    type="button">
                    Adjust Limit
                  </button>
                  <>
                    <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                      <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                      <li>
                        <button
                          onClick={endPost}
                          name="button"
                          className="dropdown-item"
                          type="button">
                            End Post
                        </button>
                      </li>
                    </ul>
                  </>
                </div>
                <button
                  onClick={updateSkipPostSummary}
                  name="button"
                  className="btn btn-primary ml-3"
                  type="button"
                >
                  {groupPost.skip_post_summary ? 'Show Post Summary': 'Skip Post Summary'}
                </button>
            </div>
          }

          {count < groupPost.limit &&
            <div className="page-actions show-mobile">
          <div className="btn-group align-center">
                <button
                  onClick={() => prepareDataForSummary('continue-later')}
                  name="button"
                  className={`btn btn-primary ${groupPost.use_media? "btn-split-left" : ""}`}
                  type="button">
                  {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                  Continue Later
                </button>
                  <>
                    <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                      <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                      {groupPost.template_id && 
                        <li>
                          <button
                            onClick={updateUseTemplate}
                            name="button"
                            className="dropdown-item"
                            type="button">
                              {groupPost.use_template ? 'Deactivate Default Template' : "Activate Default Template"}
                          </button>
                        </li>
                      }
                      {groupPost.use_media &&  
                        <li>
                          <button
                            onClick={updateAutoSelectMedia}
                            name="button"
                            className="dropdown-item"
                            type="button">
                              {groupPost.auto_select_media ? 'Deactivate Auto-Select Media' : "Activate Auto-Select Media"}
                          </button>
                        </li>
                      }
                      {groupPost.use_media &&
                        <li>
                          <button
                            onClick={editImages}
                            name="button"
                            className="dropdown-item"
                            type="button">
                              Edit Media Files
                          </button>
                        </li>
                      }
                      <li>
                        <button
                          onClick={increaseLimit}
                          name="button"
                          className="dropdown-item"
                          type="button">
                            Adjust Limit
                        </button>
                      </li>

                      <li>
                        <button
                          onClick={updateSkipPostSummary}
                          name="button"
                          className="dropdown-item"
                          type="button">
                            {groupPost.skip_post_summary ? 'Show Post Summary': 'Skip Post Summary' }
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={endPost}
                          name="button"
                          className="dropdown-item"
                          type="button">
                            End Post
                        </button>
                      </li>
                    </ul>
                  </>
              </div>
          </div>}
        </div>
        }


        <div className="card">
          <div className="card-header flex-header">
            <h4 className="card-title">
              { postData.title || 'New Post'}
            </h4>

            <div>
              {!newPost &&
                <a href='/group/post' className="btn btn-outline-danger mr-1">
                  Cancel
                </a>
              }
              <div className="btn-group">
                {newPost && count < groupPost.limit &&
                <button
                onClick={() => prepareDataForSummary('proceed')}
                  name="button"
                  className="btn btn-primary"
                  type="button">
                  Next
                </button>
                }
                {newPost && count == groupPost.limit &&
                <button
                onClick={() => prepareDataForSummary('save-post')}
                  name="button"
                  className="btn btn-primary"
                  type="button">
                  Finish
                </button>
                }
                {!newPost &&
                <button
                onClick={() => prepareDataForSummary('edit-post')}
                  name="button"
                  className="btn btn-primary"
                  type="button">
                  Save Post
                </button>
                }
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
              <div className="form-group">
                <GroupPostInfoModal />
              </div>
              </div>
            </div>
            {postData.owner && postData.owner.user_type == 'donor' &&
              <div className="row align-center">
                <div className="col-md-6 align-center">
                  <div className="form-group">
                    <ToggleSwitch
                      small
                      id="post_type"
                      checked={postData.post_type && postData.post_type == 'project' ? true : false}
                      onChange={checked => {
                        let type = checked ? 'project' : 'user'
                        setPostData(postData => {
                          return { ...postData, post_type: type, audience: [] }
                        });
                        setUsingAudience(false)
                      }}
                    />
                    {postData.post_type && postData.post_type == 'project' &&
                      <label htmlFor="post_type">{team.project_title} post</label>
                    }
                    {(!postData.post_type || postData.post_type !== 'project') &&
                      <label htmlFor="post_type">{team.donor_title} post</label>
                    }
                  </div>
                </div>

                <div className="col-md-6 align-center">
                </div>
              </div>
            } 
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="title">Title</label>
                  <input className="form-control" placeholder="New Post" type="text" name="title" id="title"
                    value={postData.title}
                    onChange={e => {
                      const val = e.target.value;
                      setPostData({...postData, title: val})
                      setDirty(true)
                      setTemplate(template => {
                        return { ...template, title: val }
                      });
                      setShowTemplateTitle(true)
                    }}
                    onBlur={() => setTimeout(() => setShowTemplateTitle(false), 400)}
                  />

                <div>
                  {isDirty && showTemplateTitle && postData.title.length > 0 &&
                    <div className="template-class-cu">
                      <TemplateDropdown data={
                        templates.filter(template => String(template.title).toLowerCase().includes(postData.title.toLowerCase()))
                      }
                      fillTemplate={(value) => fillTemplate(value)}
                      />
                    </div>
                  }

                  {titleVariable && allowedVariables &&
                    <div style={{marginTop: '10px'}}>
                      <TemplateVariableCard post={template} current_user={user} senderVariables={senderVariable}
                      receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                      useVariable={(value) => useTitleVariable(value, postData, setPostData, setTitleVariable)} realign={true}
                      />
                    </div>
                  }
                </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="published_on">Published on</label>
                  <Flatpickr className="form-control"
                    value={postData.date}
                    onChange={(date, dateStr) => {
                      setPostData({...postData, date: dateStr})
                      setDirty(true)
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                {allowManagerPosts && (
                <div className="form-group" role="group" aria-labelledby="postAsLabel">
                  <label id="postAsLabel">Post as</label>
                  <div className="input-group">
                    <Select
                      className="w-100"
                      onChange={(person) => {
                        setDirty(true)
                        setPostData(current => ({...current, owner: person, audience: []}))
                      }}
                      options={ownerOptions}
                      getOptionLabel={(person) =>
                        `${person.first_name} ${person.last_name}`
                      }
                      getOptionValue={(person) => person.id}
                      value={postData.owner}
                    />
                  </div>
                </div>
                )}

                <div className="form-group">
                  <label htmlFor="audience">Who can see this post?</label>

                  {!usingAudience && (<div>
                    <span>Visible to all your connections within Clarity. </span>
                    {hasPotentialAudience && <span><u><span className="text-primary cursor-pointer" onClick={() => setUsingAudience(true) }>Change audience</span></u>.</span>}
                  </div>)}

                  {usingAudience && (
                    <>
                      {(!postData.post_type || postData.post_type == 'user') &&
                        <>
                      <div className="input-group">
                        <Select
                          className="w-100 select-audience"
                          classNamePrefix="select-audience"
                          isMulti
                          value={postData.audience}
                          onChange={(value) => {
                              setDirty(true)
                              setPostData({...postData, audience: value})
                          }}
                          options={
                            postData.post_type == 'project' ?
                            audienceOptions.filter(option => option.type && option.type == 'project') :
                            audienceOptions.filter(option => !option.type || option.type == 'user')
                          }
                          getOptionLabel={audience => `${audience.name}`}
                          getOptionValue={audience => audience.id }
                        />
                      </div>
                      <div className="description">
                        Leave empty for all your connections within Clarity to see this post.
                      </div>
                    </>}
                    {postData.post_type && postData.post_type == 'project' &&
                      <>
                        <div className="input-group">
                          <Select
                            className="w-100 select-audience"
                            classNamePrefix="select-audience"
                            value={postData.audience[0]}
                            onChange={(value) => {
                              setPostData(postData => {
                                setDirty(true)
                                return { ...postData, audience: [value], public_project_audience: false }
                              });
                            }}
                            options={
                              postData.post_type == 'project' ?
                              audienceOptions.filter(option => option.type && option.type == 'project') :
                              audienceOptions.filter(option => !option.type || option.type == 'user')
                            }
                            getOptionLabel={audience => `${audience.name}`}
                            getOptionValue={audience => audience.id }
                          />
                        </div>
                        <div className="description">
                          You can only choose one {team.project_title.toLowerCase()} per post and it is required
                        </div>
                      </>
                    }
                  </>
                )}
                </div>
                {postData.post_type == 'project' && postData.audience && postData.audience.length > 0 && !postData.audience[0].public_disabled && 
                (!postData.audience[0].blocked_sponsors || postData.audience[0].blocked_sponsors.length < 1 || 
                  !postData.audience[0].blocked_sponsors.includes(postData.owner.id)) &&
                <div className="align-center">
                  <div className="form-group">
                    <ToggleSwitch
                      small
                      id="public_project_audience_toggle"
                      checked={postData.public_project_audience}
                      onChange={checked => {
                        setPostData({...postData, public_project_audience: checked})
                      }}
                    />
                    <label htmlFor="public_project_audience_toggle">
                      {postData.public_project_audience &&
                        <>
                          Public post (<small>visible to {team.project_title.toLowerCase()} admins and sponsors </small>)
                        </>
                      }
                      {!postData.public_project_audience &&
                        <>
                          Private post (<small>visible only to {team.project_title.toLowerCase()} admins</small>)
                        </>
                      }
                    </label>
                  </div>
                </div>
              }
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="body">Content</label>
                  <textarea className="form-control textarea-resizable" name="content" id="body" rows={15}
                    value={postData.content}
                    onChange={e => {
                      const val = e.target.value;
                      setPostData({...postData, content: val})
                      setDirty(true)
                      setTemplate(template => {
                        setDirty(true)
                        return { ...template, content: val }
                      });
                      setShowTemplateContent(true)
                    }}
                    onBlur={() => setTimeout(() => {
                      setShowTemplateContent(false)
                    }, 400)}
                  ></textarea>

                  <div>
                    {isDirty && showTemplateContent && postData.content.length > 1 &&
                      <div className="template-class-cu">
                        <TemplateDropdown data={
                          templates.filter(template => String(template.content).toLowerCase().includes(postData.content.toLowerCase()))
                        }
                        fillTemplate={(value) => fillTemplate(value)}
                        />
                      </div>
                    }

                    {templateVariable && allowedVariables &&
                      <div style={{marginTop: '10px'}}>
                        <TemplateVariableCard post={template} current_user={user} senderVariables={senderVariable}
                        receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                        useVariable={(value) => useVariable(value)} realign={true}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Selected files */}
        {postData.files.length > 0 &&
          <div className="card">
          <div className="card-header flex-header">
            <div>
              <h4 className="card-title">
                Selected Files
              </h4>
            </div>
            <div>
            </div>
          </div>

          <div className="card-body">
            <PostUploadsBlock uploads={postData.files} unselectFile={(data) => unselectFile(data)} unselect={true}/>
          </div>
        </div>}

        {/* Select files */}
        {groupPost.use_media &&
          <div className="card">
          <div className="card-header">
            <div className="row">
                <div className="col-md-8">
                  <h4 className="card-title">
                    Click the files you want to use in this post
                  </h4>
                    {data && data.length > 0 &&
                      <div>
                        <ToggleSwitch
                        small
                        id="media_toggle"
                        checked={filterMedia}
                        onChange={checked => {
                        setFilterMedia(checked)
                        }}
                      />
                        <label htmlFor="media_toggle">Remove files used in previous posts from the list</label>
                      </div>
                    }
                    <div className='mt-2'>
                      <button className='btn btn-primary btn-sm' onClick={addAllImages}>
                        Select All Images
                      </button>
                    </div>
                </div>
                <div className="col" role="group" aria-labelledby="postAsLabel">
                      <label>Select media filter</label>
                      <div className="input-group">
                        <Select
                          className="w-100"
                          onChange={(filter) => {
                            setSelectedFilter(filter)
                            filterWithSelection(filter)
                            setFilterInput('')
                          }}
                          options={filterOptions}
                          getOptionLabel={filtered => `${filtered.name}`}
                          getOptionValue={(filterName) => filterName}
                          value={selectedFilter}
                        />
                      </div>
                </div>
                </div>

                <div className="row align-center mt-3">
                  <div className="col-md-12">
                      <div className="" data-toggle="tooltip" data-placement="right" title="Search profile fields for any full or partial query.">
                          <div className="input-group">
                              <input type="text" name="q" placeholder="Search by file name in combination with the current filter"
                              autocomplete="off" className="form-control" value={filterInput}
                              onChange={(e) => {
                                setFilterInput(e.target.value)
                              }}
                              />
                          </div>
                      </div>
                  </div>
                </div>
            <div>
            </div>
          </div>

          <div className="card-body cu-over">
            <PostUploadsBlock uploads={renderedAssets.filter(media => {
              if (media.filename.toLowerCase().includes(filterInput)) {
                return media
              }
            })} selectFile={(data) => selectFile(data)} select={true}/>
          </div>
        </div>}

        {openLimit &&
          <IncreaseLimit 
            post={{
              id: groupPost.id, 
              user_id: groupPost.user_id, 
              limit: groupPost.limit
            }} 
            close={(limit = null) => {
              setOpenLimit(false)
              if (limit) {
                setGroupPost({...groupPost, limit: limit})
                if (limit == data.length) window.location = '/group/post'
              }}
            }
            postCount={data.length}
          />
        }

        {showPostSummary && 
          <SummaryModal
            data = {postSummary}
            handleClose ={ () => {
              setShowPostSummary(false);
              setPostSummary({sender: '', receiver: ''});
            }}
            handleProceed = {() => runRelevantAction(postSummary.action)}
            saving= {saving}
          />
        }

        {openMediaGuide && 
          <InfoModal team={team} close={() => setOpenMediaGuide(false)} />
        }

      </div>

      {!newPost &&
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div 
                  className="card-header d-flex align-items-center justify-content-between"
                  style={{cursor: 'pointer'}}
                  onClick={() => setOpenDelete(!openDelete)}
                >
                  Delete Post
                  <i className="card--accordion-icon fa fa-chevron-down"></i>
                </div>
                {openDelete &&
                  <div className="card-body">
                    <div className="form-group">
                        <button 
                          className='btn btn-danger'
                          onClick={() => {if (window.confirm('Are you sure you want to delete this post')) handleDelete(post)}}
                        >
                          Delete
                        </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
  )
}

export default Form

Form.propTypes = {
  posts: PropTypes.object
};
